<template>
    <div>
        <div class="loader" v-if="loading"></div>
        <div v-else>
            <div class="btn-toolbar justify-content-between mb-2 mt-1" role="toolbar">
                <div class="col-w">
                    <div class="d-flex flex-row pt-2">
                        <vs-radio v-for="filter in filterSettings"
                                  :key="filter.id"
                                  v-model="activeFieldFilter"
                                  :vs-name="'activeFieldFilter' + _uid"
                                  :vs-value="filter.id">
                            <span class="mr-1" v-cloak>{{ isEnVersion ? filter.textEn : filter.text }}</span>
                        </vs-radio>
                    </div>
                </div>
                <div class="input-group">
                    <input v-model="searchQuery"
                           v-on:keyup.enter.stop="massSearch"
                           v-on:keyup.esc.stop="clearFilters"
                           type="text"
                           class="form-control"
                           aria-label="Mass search input"
                           aria-describedby="massSearch" />
                    <button class="btn btn-secondary" @click.stop="massSearch">
                        <i class="fas fa-search"></i>
                        {{ $t('buttons.search.btnText') }}
                    </button>
                    <button class="btn btn-secondary" @click.stop="clearFilters">
                        <i class="fas fa-times"></i>
                        {{ $t('buttons.clearFilters.btnText') }}
                    </button>
                </div>
            </div>
            <div>
                <kendo-datasource ref="datasource1"
                                  :transport="transportSettings"
                                  :schema-model-id="'id'"
                                  :schema-model-fields="schemaModelFields"
                                  :schema-total="'count'"
                                  :schema-data="'items'"
                                  :page-size='gridOptions.pageable.size'
                                  :server-paging="false"
                                  :server-sorting="false"
                                  :server-filtering="false"
                                  :error="dataSourceError"
                                  :requestEnd="datasorceRequestEnd">
                </kendo-datasource>

                <kendo-grid ref="formCompletedGrid"
                            id="formCompletedGrid"
                            :data-source-ref="'datasource1'"
                            :columns="columns"
                            :pageable="gridOptions.pageable"
                            :navigatable="gridOptions.navigatable"
                            :editable="gridOptions.editable"
                            :filterable="gridOptions.filterable"
                            :reorderable="gridOptions.reorderable"
                            :resizable="gridOptions.resizable"
                            :groupable="gridOptions.groupable"
                            :allow-copy="gridOptions.allowCopy"
                            :column-menu="gridOptions.columnMenu"
                            :sortable-mode="gridOptions.sortable.mode"
                            :sortable-allow-unsort="gridOptions.sortable.allowUnsort"
                            :sortable-show-indexes="gridOptions.sortable.showIndexes"
                            :selectable="gridOptions.selectable"
                            :scrollable="gridOptions.scrollable"
                            :toolbar="gridOptions.toolbar"
                            :excel="gridOptions.excel"
                            :pdf="gridOptions.pdf">
                    <kendo-contextmenu @select="selectContextMenu" :target="'#formCompletedGrid'" :filter="'td'">
                        <li :id="'formEntryDetailsActive'" class="text-info"><i class="fas fa-eye"></i> {{ $t('buttons.detailsActive.btnText') }}</li>
                        <li :id="'formEntryDetailsAll'" class="text-info"><i class="fas fa-eye"></i> {{ $t('buttons.detailsAll.btnText') }}</li>
                    </kendo-contextmenu>
                </kendo-grid>
            </div>
        </div>

        <FormEntryDetailsModal v-model="formEntryDetailsModel" :show="showFormEntryDetails"
                               @onClose="onFormEntryDetailsClose"></FormEntryDetailsModal>
    </div>
</template>


<script>
    import { RegisterFieldValueQueryFilter } from '../../models/enums';
    import FormEntryDetailsModal from '../../components/forms/entryView/details.modal';
    import { mapGetters } from 'vuex';

    export default {
        name: 'form-summary-grid',
        components: {
            FormEntryDetailsModal
        },
        props: {
            formToRegisterEntityId: {
                regquired: true,
                type: Number
            },
            showPager: {
                default: true,
                type: Boolean
            }
        },
        data() {
            return {
                componentName: "FormSummaryGrid",
                formEntryDetailsModel: null,
                filterSettings: [{ id: 0, text: 'Всички', textEn: 'All' }, { id: 2, text: 'Активни', textEn: 'Active' }],
                activeFieldFilter: 2,
                showFormEntryDetails: false,
                schemaModelFields: {},
                columns: [],
                transportSettings: {
                    read: {
                        url: this.$store.getters.baseUrl + `/api/dynamicFormVisualization/loadData/`,
                        dataType: 'json',
                        type: 'POST',
                        contentType: 'application/json',
                        beforeSend: this.beforeSend
                    },
                    parameterMap: this.parameterMap
                },
                gridOptions: {
                    ...this.$store.getters.gridOptions,
                    toolbar: ['excel', 'pdf'],
                    excel: {
                        fileName: 'Forms.xlsx',
                        allPages: false,
                        filterable: true,
                        collapsible: true
                    },
                    pdf: {
                        fileName: 'Forms.pdf',
                        title: this.$t(this.titleKey),
                        subject: this.$t(this.titleKey),
                        creator: this.$store.userName,
                        allPages: false,
                        avoidLinks: true,
                        paperSize: 'A4',
                        margin: { top: '2cm', left: '1cm', right: '1cm', bottom: '1cm' },
                        landscape: true,
                        repeatHeaders: true,
                        scale: 0.6
                    }
                },
                loading: false,
                searchQuery: '',
            }
        },
        methods: {
            dataSourceError(e) {
                this.$vs.notify({
                    title: this.$t('notifications.error'),
                    text: this.$helpers.kendoDataSourceErrorText(e),
                    color: 'danger',
                    time: this.$store.getters.notificationDuration,
                });
            },
            loadSchemaModel() {
                return this.$http.post(`/api/dynamicFormVisualization/schemaModel`, { id: this.formToRegisterEntityId, activeFieldFilter: this.activeFieldFilter })
                    .then((response => {
                        if (response.data.schemaModelFields) {
                            this.schemaModelFields = JSON.parse(response.data.schemaModelFields);
                        }
                    })).catch(error => {
                        this.$vs.notify({
                            title: this.$t('request.response.status.' + this.$helpers.errorStatusCode(error)),
                            text: this.$helpers.errorText(error),
                            color: 'danger',
                            time: this.$store.getters.notificationDuration
                        });
                    });
            },
            loadGridColumns() {
                return this.$http.post(`/api/dynamicFormVisualization/gridColumns`, { id: this.formToRegisterEntityId, activeFieldFilter: this.activeFieldFilter })
                    .then((response => {
                        if (response.data.columns) {
                            this.fillColumns(JSON.parse(response.data.columns));
                        }

                        console.log("Grid colums loaded");
                    })).catch(error => {
                        this.$vs.notify({
                            title: this.$t('request.response.status.' + this.$helpers.errorStatusCode(error)),
                            text: this.$helpers.errorText(error),
                            color: 'danger',
                            time: this.$store.getters.notificationDuration
                        });
                    });
            },
            fillColumns(source) {
                let columnsArr = [];

                for (let key in source) {
                    if (source.hasOwnProperty(key)) {
                        const col = source[key]
                        let column = {
                            field: col.field,
                            width: Number(col.width),
                            title: col.title,
                            lockable: col.lockable,
                            locked: col.locked,
                            format: col.format,
                            hidden: col.hidden,
                            sortable: col.sortable,
                            filterable: col.filterable
                        };

                        if (col.isBoolean === true) {
                            const that = this;
                            column.template = function (dataItem) {
                                let templateHtml =
                                    '<span>' + kendo.htmlEncode(dataItem[col.field] ? that.$t('yes') : that.$t('no')) + '</span>';

                                return templateHtml;
                            }
                        }

                        columnsArr.push(column)
                    }
                }

                this.columns = columnsArr;
            },
            datasorceRequestEnd(e) {
                if (e.type === "read" && e.response) {
                    // console.log(e.response[0]);
                    // alert(e.respondashboard-ctrlse[0].TaskID);
                }
            },
            beforeSend: function (req) {
                if (this.authToken) {
                    req.setRequestHeader('Authorization', 'Bearer ' + this.authToken);
                }
            },
            parameterMap: function (options, operation) {
                if (operation !== 'read' && options.models) {
                    return { models: kendo.stringify(options.models) }
                } else {
                    // Викаме POST action за листване на номенклатурите и трябва да сериализираме
                    // options. Така се предава информация за take, skip , page и списък с обекти
                    // описващи сортирането
                    let newOptions = { request: options, id: this.formToRegisterEntityId, activeFieldFilter: this.activeFieldFilter };
                    return kendo.stringify(newOptions);
                }
            },
            loadGridSettings() {
                return this.loadSchemaModel()
                    .then(() => {
                        this.loadGridColumns();
                    });
            },
            clearFilters() {
                this.searchQuery = '';
                const grid = this.$refs.formCompletedGrid.kendoWidget();
                if (grid) {
                    grid.dataSource.sort({});
                    grid.dataSource.page(1);
                    grid.dataSource.aggregate([]);
                    grid.dataSource.filter({});
                }
            },
            massSearch() {
                if (!this.searchQuery) {
                    this.$vs.notify({
                        title: this.$t('buttons.search.btnText'),
                        text: this.$t('emptySearchFilter'),
                        color: 'warning',
                        time: this.$store.getters.notificationDuration
                    });

                    return;
                }

                let grid = this.$refs.formCompletedGrid.kendoWidget();
                if (grid) {
                    let filter = this.$helpers.getMassFilterForGrid(grid, this.searchQuery);
                    if (filter) {
                        grid.dataSource.filter(filter);
                    }
                }
            },
            selectContextMenu(e) {
                var btnId = e.item.id;
                var index = e.target.parentElement.rowIndex;
                var row = this.$refs.formCompletedGrid.kendoWidget().dataSource.data()[index]
                if (!row) {
                    return;
                }

                if (btnId === 'formEntryDetailsAll') {
                    if (row.id) {
                        this.showFormEntryDetailsModal({ id: row.id }, RegisterFieldValueQueryFilter.All)
                    }
                } else if (btnId === 'formEntryDetailsActive') {
                    this.showFormEntryDetailsModal({ id: row.id }, RegisterFieldValueQueryFilter.Active)
                }
            },
            showFormEntryDetailsModal(args, filter) {
                this.$api.dynamicForm
                    .getEntryDetails(args.id, filter)
                    .then(response => {
                        const model = response.data;
                        if (model) {
                            this.formEntryDetailsModel = model;
                            // this.formEntryDetailsModel.formNameEn = args.formNameEn;
                            // this.formEntryDetailsModel.eventName = args.eventName;
                            // this.formEntryDetailsModel.creatorFullName = args.creatorFullName;
                            // this.formEntryDetailsModel.createdAtUtc = args.createdAtUtc;
                            // this.formEntryDetailsModel.updatedAtUtc = args.updatedAtUtc;

                            this.showFormEntryDetails = true;
                        }
                    })
                    .catch(error => {
                        this.formEntryDetailsModel = null;
                        this.showFormEntryDetails = false;

                        this.$vs.notify({
                            title: this.$t('request.response.status.' + this.$helpers.errorStatusCode(error)),
                            text: this.$helpers.errorText(error),
                            color: this.$helpers.errorColor(error),
                            time: this.$store.getters.notificationDuration
                        })
                    });
            },
            onFormEntryDetailsClose() {
                this.showFormEntryDetails = false;
                this.formEntryDetailsModel = null;
            },
        },
        created() {
            this.loading = true;
            this.loadGridSettings()
                .catch()
                .then(() => {
                    this.loading = false;
                });
        },
        computed: {
            ...mapGetters(['isEnVersion', 'authToken'])
        },
        watch: {
            activeFieldFilter(newVal) {
                this.loading = true;
                this.loadGridSettings()
                    .catch()
                    .then(() => {
                        this.loading = false;
                    });
            }
        }
    }
</script>


<style>
</style>
